import { render, staticRenderFns } from "./ImageModelSeo.vue?vue&type=template&id=22b75175&scoped=true"
import script from "./ImageModelSeo.vue?vue&type=script&lang=js"
export * from "./ImageModelSeo.vue?vue&type=script&lang=js"
import style0 from "./ImageModelSeo.vue?vue&type=style&index=0&id=22b75175&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b75175",
  null
  
)

export default component.exports